import { render, staticRenderFns } from "./ServiceAction.vue?vue&type=template&id=57f2a15f&scoped=true"
import script from "./ServiceAction.vue?vue&type=script&lang=js"
export * from "./ServiceAction.vue?vue&type=script&lang=js"
import style0 from "./ServiceAction.vue?vue&type=style&index=0&id=57f2a15f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2a15f",
  null
  
)

export default component.exports